import React, { FC } from 'react';
import styled from '@emotion/styled';
import { style } from '../../Shared/Style';
import { Icon } from '../../Icon/Icon';
import { Colors } from '../../Shared/Style/colors';

export const SendReportButton = styled.button(() => {
    return {
        background: 'transparent',
        border: 'none',
        padding: '0.15rem',

        '&:hover': {
            cursor: 'pointer',
        },
    };
});

export const SendReportLable = styled.p(({ textcolor }: props) => {
    return {
        color: textcolor ? style.colors[textcolor] : style.colors.secondary,
        margin: 0,
        marginTop: '0.5rem',
    };
});

export const SendReportIcon = styled(Icon.CirleRightArrow)(({ arrowcolor, circlecolor }: props) => {
    return {
        display: 'block',

        '& svg': {
            width: '100%',
        },

        '& .nc-icon-wrapper': {
            'path:first-of-type': {
                // Circle
                fill: circlecolor ? style.colors[circlecolor] : style.colors.tabActive,
            },

            'path:last-of-type': {
                // Arrow
                fill: arrowcolor ? style.colors[arrowcolor] : style.colors.white,
            },
        },
        'button:disabled &': {
            'path:first-of-type': {
                // Circle
                fill: circlecolor ? style.colors[circlecolor] : style.colors.primary,
            },

            'path:last-of-type': {
                // Arrow
                fill: arrowcolor ? style.colors[arrowcolor] : style.colors.white,
            },
        },
    };
});

export type props = {
    label?: string;
    className?: string;
    onClick?: () => void;
    circlecolor?: Colors;
    arrowcolor?: Colors;
    textcolor?: Colors;
    type?: 'button' | 'submit' | 'reset' | undefined;
    disabled?: true | false;
};
const SendButton: FC<props> = ({
    textcolor,
    arrowcolor,
    circlecolor,
    className,
    label,
    type = 'submit',
    onClick,
    ...rest
}) => {
    return (
        <SendReportButton onClick={onClick} className={className} type={type} {...rest}>
            <SendReportIcon arrowcolor={arrowcolor} circlecolor={circlecolor} />
            {label && <SendReportLable textcolor={textcolor}>{label}</SendReportLable>}
        </SendReportButton>
    );
};

export default SendButton;
